
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/integrations/mercury-gate",
      function () {
        return require("private-next-pages/integrations/mercury-gate.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/integrations/mercury-gate"])
      });
    }
  